<template>
  <div class="dictionary-words">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'dicitionary-words-view'
}
</script>

<style lang="scss" scoped>

</style>
